/**
 * Map image → sprite — render-exempt file (test-spec §7.2). Loads the
 * background texture and sizes it to the grid extent; no rules.
 */

import { Assets, Container, Sprite, Texture } from "pixi.js";
import type { MapState } from "@asarimitsuha/table-core";

export interface MapSpriteHandle {
  sprite: Sprite;
  loadedUrl: string | null;
}

export function createMapSprite(world: Container): MapSpriteHandle {
  const sprite = new Sprite(Texture.EMPTY);
  sprite.position.set(0, 0);
  sprite.visible = false;
  world.addChildAt(sprite, 0); // beneath grid + tokens
  return { sprite, loadedUrl: null };
}

export async function updateMapSprite(
  handle: MapSpriteHandle,
  map: MapState,
): Promise<void> {
  if (!map.imageUrl) {
    handle.sprite.visible = false;
    handle.loadedUrl = null;
    return;
  }
  if (handle.loadedUrl !== map.imageUrl) {
    handle.loadedUrl = map.imageUrl;
    try {
      const texture = (await Assets.load(map.imageUrl)) as Texture;
      // A newer image may have loaded while we awaited.
      if (handle.loadedUrl !== map.imageUrl) return;
      handle.sprite.texture = texture;
    } catch {
      handle.sprite.visible = false;
      return;
    }
  }
  handle.sprite.visible = true;
  handle.sprite.width = map.widthCells * map.cellSizePx;
  handle.sprite.height = map.heightCells * map.cellSizePx;
}
